import React, { useEffect } from "react";
import { initLuxuryMotion } from "./utils/animations";
import AmbientBackground from "./components/AmbientBackground";
import CustomCursor from "./components/CustomCursor";
import Section from "./components/Section";
import Navbar from "./components/Navbar";
import CustomColorDemo from "./components/demo";
import Hero from "./components/Hero";
import About from "./components/About";
import Tech from "./components/Tech";
import Experience from "./components/Experience";
import Works from "./components/Works";
import Feedbacks from "./components/Feedbacks";
import Education from "./components/Education";
import Certificates from "./components/Certificates";
import Contact from "./components/Contact";

/* ═══════════════════════════════════════════════════════════
   APP — Luxury Portfolio
   Obsidian & Champagne · unified motion language
   ═══════════════════════════════════════════════════════════ */

const App = () => {
  useEffect(() => {
    // Global motion scope — cursor, parallax, reveals
    const cleanup = initLuxuryMotion(document);
    return cleanup;
  }, []);

  return (
    <div className="relative min-h-screen bg-obsidian-950 text-silver-200">
      {/* Global ambient layers */}
      <AmbientBackground />
      <div className="grain" aria-hidden="true" />
      <CustomCursor />

      {/* Content */}
      <div className="relative z-10">
        {/* <Navbar /> */}
        <CustomColorDemo/>

        <main>
          {/* Hero — full viewport, no section padding */}
          <Section id="home">
            <Hero />
          </Section>

          <hr className="lux-divider" />

          <Section id="about">
            <About />
          </Section>

          <Section id="capabilities">
            <Tech />
          </Section>

          <hr className="lux-divider" />

          <Section id="experience">
            <Experience />
          </Section>

          <Section id="projects">
            <Works />
          </Section>

          <Section id="testimonials">
            <Feedbacks />
          </Section>

          <Section id="education">
            <Education />
          </Section>

          <Section id="certificates">
            <Certificates />
          </Section>

          <hr className="lux-divider" />

          <Section id="contact">
            <Contact />
          </Section>
        </main>
      </div>
    </div>
  );
};

export default App;